module.exports = __webpack_public_path__ + "img/9.8612916b.jpg";